import React, { useState } from 'react';

const tabButtonStyle = (active) => ({
    padding: '0.6rem 1.1rem',
    background: 'none',
    border: 0,
    borderBottom: active ? '3px solid #1779ba' : '3px solid transparent',
    color: active ? '#1779ba' : '#555',
    fontWeight: active ? 600 : 400,
    fontSize: '0.9rem',
    cursor: 'pointer',
    marginBottom: '-1px',
});

// tabs: [{ key, label, content }] - only the content of the active tab is rendered
const Tabs = ({ tabs, defaultKey }) => {
    const [activeKey, setActiveKey] = useState(defaultKey ?? tabs[0]?.key);
    const active = tabs.find((tab) => tab.key === activeKey) || tabs[0];

    return (
        <div>
            <div role="tablist" style={{ display: 'flex', flexWrap: 'wrap', borderBottom: '1px solid #e5e7eb', marginBottom: '1rem' }}>
                {tabs.map((tab) => (
                    <button
                        key={tab.key}
                        type="button"
                        role="tab"
                        aria-selected={tab === active}
                        style={tabButtonStyle(tab === active)}
                        onClick={() => setActiveKey(tab.key)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>
            <div role="tabpanel">{active?.content}</div>
        </div>
    );
};

export default Tabs;
